import { DataManager } from 'utils/DataManager/dataManager';
import httpsService from 'stores/http-service';

class UserDataManager extends DataManager {
    // The following method is used before the store or
    // the singletons are initiated
    static getUserInfo(): Promise<IUserInfo|null> {
        return httpsService.get<IUserInfo>(
            '/api/users/info', false);
    }

    // The following method is used before the store or
    // the singletons are initiated
    static mapUser(): Promise<void|null> {
        return httpsService.post<null, void>(
            '/api/users/usermapping', null);
    }

    static setHasTeamCookie(): void {
        document.cookie = `hasTeamAccount=true; expires=; domain=${this.rootDomain(location.hostname)}; path=/`;
    }

    static rootDomain(hostname?: Nullable<string>): string {
        if (!hostname) {
            return '';
        }

        const domainComponents = hostname.split('.').reverse();
        if (domainComponents.length === 1) {
            return domainComponents[0];
        }
        return `${domainComponents[1]}.${domainComponents[0]}`;
    }

    async clearUserInfo(): Promise<void> {
        const teamServiceElement = document.getElementById('teamservice');
        if (!teamServiceElement) {
            return;
        }
        const jobCollabBackendUrl = teamServiceElement.dataset.jobcollabbackendurl;
        await Promise.all([
            this._deleteDataRequest<void>('/api/users/info'),
            this._deleteDataRequest<void>('cookie/MasterAccountId', jobCollabBackendUrl)
        ]);
    }

    getSuggestedUsers(
        masterAccountId: string,
        searchText: string,
        resultLimit: number,
        includeAll: boolean
    ): Promise<Nullable<ISuggestedUser[]>> {
        const option = `?searchText=${searchText}&resultLimit=${resultLimit}&includeAll=${includeAll}`;
        const receive = () => this._getDataRequest<ISuggestedUser[]>(
            `/api/accounts/${masterAccountId}/users/humanresource/suggested${option}`);
        return this.getData<ISuggestedUser[]>(receive, false);
    }
}

export { UserDataManager };
export default UserDataManager;